<style>
	/* 	.el-input__inner{
		width: 50%;
	} */
	.el-input {
		text-align: left !important;
	}
	.el-form-item__content {
		text-align: left !important;
	}
	.form{
		display: flex;
	}
	.inputs{
		width: 460px !important;
	}
	.el-form-item__label{
		width: 170px;
		text-align: left;
	}
</style>
<template>
	<div class="edit">
		<div class="warning">
			<img src="@/assets/images/t.png" alt />
			<div>{{$t('modifyPsd.Tips')}}</div>
		</div>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm" :validate-on-rule-change="false">
			<el-form-item :label="$t('modifyPsd.Original')" prop="pPassword" class="form">
				<el-input v-model="ruleForm.pPassword" type="password" class="inputs"></el-input>
			</el-form-item>
			<el-form-item :label="$t('modifyPsd.new')" prop="nPassword" class="form">
				<el-input v-model="ruleForm.nPassword" type="password" class="inputs"></el-input>
			</el-form-item>
			<el-form-item :label="$t('modifyPsd.confirm')" prop="sPassword" class="form">
				<el-input v-model="ruleForm.sPassword" type="password" class="inputs"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submitForm('ruleForm')">{{$t('modifyPsd.modify')}}</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				ruleForm: {
					pPassword: '', //原
					nPassword: '', //新
					sPassword: '', //确认
				},
				rules: {},
			};
		},
		mounted() {
			this.rules = this.$t('modifyPsd.rules')
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.nPassword !== this.sPassword) {
							this.$message({
								message: this.$t('modifyPsd.msgTips'),
								type: 'warning'
							});
							return false;
						}
						let url = '/api/user/updatePassword'
						let data = {
							oldPassword: this.ruleForm.pPassword,
							password: this.ruleForm.sPassword,
							token: sessionStorage.getItem('token')
						}
						this.$put(url, data).then(res => {
							if (res.code == 0) {
								this.$message({
									message: this.$t('modifyPsd.modifysuc'),
									type: 'success'
								});
								setTimeout(() => {
									this.$router.go(-1)
								}, 2000)
							}
						})
					} else {
						return false;
					}
				});
			},
		}
	};
</script>
<style scoped>
	.el-input__inner {
		width: 50% !important;
	}

	div {
		box-sizing: border-box;
	}

	.edit {
		width: 100%;
		height: 100%;
		padding: 26px 33px;
	}

	.warning {
		display: flex;
		align-items: center;
		background: #fbf7f4;
		height: 40px;
		padding-left: 15px;
		color: #fe4646;
		font-size: 14px;
		margin-bottom: 31px;
	}

	.warning img {
		width: 20px;
		height: 20px;
		margin-right: 9px;
	}

	.list {
		margin-bottom: 20px;
		display: flex;
		align-items: center;
	}

	.inp {
		padding-left: 19px;
		height: 42px;
		margin-left: 19px;
		background: #f6f4f5;
		width: 468px;
		border-radius: 3px;
	}

	.inp.red {
		background: #fef6f2;
		border: 1px solid #fa8772;
	}

	.red_font {
		margin-left: 20px;
		font-size: 14px;
		color: #fa2f0a;
	}

	.name {
		width: 90px;
		text-align: right;
	}

	.btn {
		width: 124px;
		height: 36px;
		background: linear-gradient(0deg,
			rgba(5, 115, 203, 1) 0%,
			rgba(63, 159, 234, 1) 100%);
		border-radius: 2px;
		font-size: 14px;
		line-height: 36px;
		color: #fff;
		margin-left: 19px;
	}
</style>



// WEBPACK FOOTER //
// src/components/memberCenter/sub/EditPassword.vue